export default __webpack_public_path__ + "static/media/you-bottom.39ba2aac.png";